import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { LabelDividerRow } from '@/feature/betslip-pickem/components/LabelDividerRow';
import { MULTIPLIER_BG_COLOR } from '@/feature/betslip-pickem/utils/game-mode-utils';
import { useP2pFaq } from '@/feature/p2p-faq/components/P2pFaqProvider';

export const GuaranteedPrizeSection = ({ description, prizeLabel }: { description: string; prizeLabel: string }) => {
    const { t } = useTranslation('betslip_pickem');
    const { showP2pFaqModal } = useP2pFaq();
    return (
        <Box>
            <LabelDividerRow leftText={t('or')} />
            <Row paddingVertical={'s8'}>
                <Text mr={'s8'} color={ds.colorToken.text.primary}>
                    {t('first_place_in_group')}
                </Text>
                <Row paddingVertical={'s4'} borderRadius={'r7'} style={styles.multiplier}>
                    <Text variant={'labelMedium'} color={ds.colorToken.text.brand}>{`${t('up-to')}${prizeLabel}`}</Text>
                </Row>
            </Row>
            <Text variant={'bodySmall'} letterSpacing={-0.08} color={'neutral300'} paddingTop={'s4'}>
                {description}
                <Text
                    variant={'titleSmall'}
                    letterSpacing={-0.08}
                    color={'neutral300'}
                    textDecorationLine={'underline'}
                    onPress={() => showP2pFaqModal()}
                >
                    {t('learn_more')}
                </Text>
            </Text>
        </Box>
    );
};

const styles = StyleSheet.create({
    multiplier: {
        paddingHorizontal: 7,
        backgroundColor: MULTIPLIER_BG_COLOR,
    },
});
